import axios from "axios";
import { isMobileSafari, isSafari, osName } from "react-device-detect";
import { serverResponse } from "../util/fakeServer";
import { BREAKPOINT } from "./constant";
import ReactGA from "react-ga";
import { language } from "../languageProvider/language/language";
import {
  plusIcon,
  worldIcon,
  playIcon,
  hatChefIcon,
  specsIcon,
  promoIcon,
  infoIcon
} from "./constant";
import { gaEventLabel } from "../settings/gaConfig";
import { sendEvent } from "../services/analytics.services";

var isMobile = window.innerWidth < BREAKPOINT.lg;

const showOnePage = serverResponse.config.show_one_page || isMobile;
const hasIndex = serverResponse.leaflet.index !== null;
const nMax = serverResponse.leaflet.pages.length;

export const defaultLanguage = "it_IT";

const getInitialShowOnePage = () => {
  let r = false;
  if (window.innerWidth < BREAKPOINT.lg) {
    r = true;
  } else if (serverResponse.config.show_one_page) {
    r = true;
  }
  return r;
};

export const getValue = (input) => {
  let tempShowOnePage = global.showOnePage || getInitialShowOnePage();
  let tempHasIndex = serverResponse.leaflet.index !== null;
  if (Number.isNaN(input) || input <= 0) {
    return 0;
  } else if (input > nMax) {
    return tempShowOnePage ? nMax : Math.floor(nMax / 2);
    // return tempHasIndex ? temp_m : temp_m - 1;
  } else if (tempShowOnePage) {
    return tempHasIndex ? input : input - 1;
  } else {
    return input % 2 === 0 ? input / 2 : (input - 1) / 2;
  }
};

export const formatterText = (string) => {
  if (!string) {
    return;
  }
  return string
    .replace("&amp;", "&")
    .replace("&gt;", ">")
    .replace("&lt;", "<")
    .replace("&quot;", '"')
    .replace("&euro;", "€")
    .replace("&apos;", "'");
};

export const setLabelSlider = (index) => {
  let temp = index * 2 + 1 > nMax ? "" : " - " + (index * 2 + 1);
  let tempShowOnePage =
    global.showOnePage || serverResponse.config.show_one_page;
  let tempHasIndex = serverResponse.leaflet.index !== null;
  if (isNaN(index) || index <= 0) {
    return tempHasIndex && tempShowOnePage
      ? language[defaultLanguage].indice
      : 1;
  }
  if (tempShowOnePage) {
    if (index === 0) {
      return tempHasIndex ? language[defaultLanguage].indice : 1;
    } else {
      return tempHasIndex ? index : index + 1;
    }
  } else {
    if (index === 0) {
      return 1;
    } else {
      return index * 2 + temp;
    }
  }
};

export const defaultState = () => {
  let status,
    carouselIndex = 0,
    slideMax;

  if (!showOnePage && hasIndex) {
    status = 1;
    if (nMax % 2 !== 0) {
      slideMax = (nMax + 1) / 2;
    } else {
      slideMax = Math.round(nMax / 2) + 1;
    }
  } else if (!showOnePage && !hasIndex) {
    status = 2;
    if (nMax % 2 !== 0) {
      slideMax = Math.round(nMax / 2);
    } else {
      slideMax = nMax / 2;
    }
  } else if (showOnePage && hasIndex) {
    status = 3;
    slideMax = nMax + 1;
  } else {
    status = 4;
    slideMax = nMax;
  }

  if (isMobile && status === 3) {
    carouselIndex = 0;
  }

  if (nMax === 1) {
    slideMax = 1;
  }

  return {
    loading: false,
    slideMax,
    status,
    carouselIndex,
    labelIndex: setLabelSlider(carouselIndex),
    fromInput: false,
    firstLoad: false,
    zoomValue: 1,
    buttonCarouselDisabled: false,
    refZoom: {},
    modalOpen: false,
    sidebarRightOpen: false
  };
};

export const gAInitializer = () => {
  if (serverResponse.config.ga_active) {
    ReactGA.initialize(serverResponse.config.ga_tracking_id, {
      gaOptions: { cookieFlags: "max-age=7200;secure;samesite=none" }
    });
  }
};

export const checkMobileOs = () => {
  let listOs = ["android", "ios"];

  return listOs.includes(osName.toLowerCase().trim());
};

export const lightenDarkenColor = (color, percent) => {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  var RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
  var GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
  var BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
};

export const getPager = () => {
  let slides_count = global.showOnePage ? nMax : Math.floor(nMax / 2);
  let pager = null;
  if (nMax > 1) {
    if (serverResponse.config.pager === "index") {
      pager = "index";
    } else if (serverResponse.config.pager === "slider") {
      pager = slides_count < 7 ? "buttons" : "slider";
    } else if (serverResponse.config.pager === "buttons") {
      if (global.showOnePage) {
        pager = slides_count > 8 ? "slider" : "buttons";
      } else {
        pager = slides_count > 15 ? "slider" : "buttons";
      }
    }
  }

  return pager;
};

export const getCustomActions = () => {
  let obj = {
    component: "Default",
    sendList: (exportObj, idParam) => {
      axios
        .post("https://portal.interattivo.net/api/listaspesa/write", exportObj)
        .then(function(response) {
          const encodeString = Buffer.from(
            `client_id=${serverResponse.config.client_id}&signboard_id=${serverResponse.config.signboard_id}&list_id=${idParam}&id_publication=${serverResponse.leaflet.id}`
          ).toString("base64");
          var send_grocery_list_url =
            "https://portal.interattivo.net/clienti/checkout/index?params=" +
            encodeString;
          window.location = send_grocery_list_url;
        })
        .catch(function(error) {
          alert("Spiacenti, si è verificato un errore");
          console.log(error.response);
        });
    },
    bgTotalList: serverResponse.config.primary_color,
    exportList: (exportObj) => {
      axios.post("https://api.volantinointerattivo.net/api/write", exportObj);
    },
    get_read_api_url: (id, id_campaign) =>
      `https://api.volantinointerattivo.net/api/read?id=${id}`,
    get_product_api_url: (res) => res.data,
    backToLeaflet: (func_write, func_history) => null,
    get_list_container_class: "custom-container",
    getShareListLink: (idParam) =>
      serverResponse.config.serverPath + "myGroceryList/" + idParam,
    classColumn: true,
    listData: (el) => el.data,
    isIframe: () => {
      try {
        return window.self !== window.top;
      } catch (error) {
        return;
      }
    },
    cookieConsent: false,
    getInteractivity: (item_id) => {
      return serverResponse.interactivities[item_id];
    }
  };

  switch (serverResponse.config.client_id) {
    case 137:
      return {
        ...obj,
        component: "Giodicart",
        sendList: (exportObj, idParam, bool, wo = null) => {
          axios
            .post(
              "https://portal.interattivo.net/api/listaspesa/write",
              exportObj
            )
            .then(function(response) {
              let l = `https://www.giodicart.it/vi/${idParam}`;
              const openTo = isMobileSafari ? "_self" : "_blank";

              if (bool) {
                if (isSafari) {
                  wo.location = l;
                } else {
                  window.open(`${l}`, openTo);
                }
              }
            })
            .catch(function(error) {
              alert(`Spiacenti, si è verificato un errore ${error}`);
              console.log(error.response);
            });
          return;
        },
        bgTotalList: "#ff0000",
        exportList: (exportObj) => {
          axios
            .post(
              "https://portal.interattivo.net/api/listaspesa/write",
              exportObj
            )
            .catch(function(error) {
              alert("Spiacenti, si è verificato un errore");
              console.log(error.response);
            });
        },
        get_read_api_url: (id) =>
          `https://portal.interattivo.net/api/listaspesa/read?id_param_url=${id}&id_campagna=${serverResponse.leaflet.id_campaign}`,
        get_product_api_url: (res) => {
          let tmp_product = res.data.data.map((p) => {
            let temp_p = p.prices !== "" ? JSON.parse(p.prices) : null;
            let temp_v = p.variety === "" ? undefined : p.variety;
            return { ...p, prices: temp_p, variety: temp_v };
          });
          return tmp_product;
        },
        backToLeaflet: (func_write, func_history) => {
          func_write();
          func_history.push("/leaflet?cart=1");
        },
        get_list_container_class: "custom-container d-none",
        getShareListLink: (idParam) =>
          serverResponse.leaflet.code === "15"
            ? `https://giodicart.education/c/${idParam}`
            : `https://giodicart.education/p/${serverResponse.config.slug}/c/${idParam}`,
        classColumn: true,
        listData: (el) => el.data.data,
        cookieConsent: true,
        getInteractivity: (item_id) => {
          return serverResponse.interactivities[item_id];
        }
      };

    default:
      return obj;
  }
};

export const encodeN = (n) => {
  const key = [4, 5, 6, 7, 8, 9, 0, 1, 2, 3];
  return key[n];
};

export const iconsObj = {
  plus: {
    icon: plusIcon,
    gaLabel: gaEventLabel.open_product
  },
  world: {
    icon: worldIcon,
    gaLabel: gaEventLabel.open_product_link
  },
  play: {
    icon: playIcon,
    gaLabel: gaEventLabel.open_product_video
  },
  info: {
    icon: infoIcon,
    gaLabel: gaEventLabel.open_product_curiosity
  },
  "hat-chef": {
    icon: hatChefIcon,
    gaLabel: gaEventLabel.open_product_recipe
  },
  specs: {
    icon: specsIcon,
    gaLabel: gaEventLabel.open_product_specifications
  },
  promo: {
    icon: promoIcon,
    gaLabel: gaEventLabel.open_promo
  },
  external_link: {
    icon: worldIcon,
    gaLabel: gaEventLabel.open_product_link
  },
  internal_link: {
    icon: worldIcon,
    gaLabel: gaEventLabel.open_product_link
  }
};

export const getPagesFromLabel = (str) => str.split(" - ");

export const formatter = (dataGiodi) => {
  let formattedData = {};
  const nestedData = dataGiodi.data.data[0].data;
  let temp_name_product = "";

  for (let index = 0; index < nestedData.length; index++) {
    const itemValue = nestedData[index];
    if (index === 0) {
      temp_name_product = itemValue["name"].split(" ");

      formattedData.codice_interno_insegna = itemValue["skul"];
      formattedData.product_id = itemValue["skul"];
      formattedData.sku = itemValue["sku"];
      formattedData.skul = itemValue["skul"];
      formattedData.item_id = itemValue["skul"];
      formattedData.field1 = itemValue["name"];
      formattedData.field2 = itemValue["brand"];
      formattedData.field3 = itemValue["line"];
      formattedData.field4 = itemValue["age"];
      formattedData.min_order_qty = itemValue["min_order_qty"];
      formattedData.description =
        formattedData.field1 +
        " " +
        formattedData.field2 +
        " " +
        formattedData.field3 +
        " " +
        formattedData.field4;
      formattedData.photo = itemValue["photo"];
      formattedData.price = +itemValue["price"];
      formattedData.price_label = `€ ${parseFloat(itemValue["price"])
        .toFixed(2)
        .toString()
        .replace(".", ",")}`;
      formattedData.strike_price = +itemValue["strike_price"];
      formattedData.discount_rate = itemValue["discount_rate"];
      formattedData.prices = itemValue["prices"];
      formattedData.promo = itemValue["promo"];
      formattedData.stock = itemValue["stock"];
      formattedData.tdc = itemValue["tdc"];
      formattedData.from = itemValue["from"];
      formattedData.brand = itemValue["brand"];
      formattedData.brand_logo = itemValue["brand_logo"];
      formattedData.line = itemValue["line"];
      formattedData.line_logo = itemValue["line_logo"];
      formattedData.varieties = [];
      formattedData.related = [];
      formattedData.descrizione_estesa = itemValue["info"];
      formattedData.thumb = itemValue["thumb"];
      formattedData.quantity_step = 1;
      formattedData.grocery_label = "pz.";
      formattedData.image_file = itemValue["photo"];
      formattedData.equivalence = 1;
      let didattica_categories = [];
      let images = [];
      images.push({ image_file: itemValue.photo, cropped: true });
      for (let all_category of itemValue["paths"]) {
        try {
          for (let category of all_category) {
            didattica_categories.push({
              id: category[0],
              name: category[1]
            });
          }
        } catch (error) {
          continue;
        }
      }

      if (didattica_categories.length === 0) {
        formattedData.cats = itemValue["paths"];
      } else {
        formattedData.cats = didattica_categories;
      }

      formattedData.id_category = formattedData.cats[0]["id"];
      formattedData.category = formattedData.cats[0]["name"];
      formattedData.id_subcategory = formattedData.cats[1]["id"];
      formattedData.subcategory = formattedData.cats[1]["name"];
      formattedData.images = images;
    } else {
      let temp_name_related = itemValue["name"].split(" ");
      if (index === 1) {
        formattedData["varieties"] = temp_name_product.filter(
          (item) => !temp_name_related.includes(item)
        );
        let temp_var = [];
        temp_var.push(formattedData["varieties"].join(" "));
        formattedData["varieties"] = temp_var;
      }

      let related_item = {
        sku: itemValue["sku"],
        skul: itemValue["skul"],
        image: itemValue["photo"],
        variety: temp_name_related.filter(
          // eslint-disable-next-line no-loop-func
          (item) => !temp_name_product.includes(item)
        )
      };
      formattedData.related.push(related_item);
    }
  }

  return formattedData;
};

export const getPageNumber = (skul) => {
  let numberFlag = false;
  let pages = serverResponse.pages;
  let pages_keys = Object.keys(serverResponse.pages);
  let count = 1;
  while (!numberFlag && count <= +pages_keys[pages_keys.length - 1]) {
    if (pages[count].includes(skul)) {
      numberFlag = true;
    } else {
      count++;
    }
  }
  return count;
};

export const downloadFile = (data, type) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `MyGroceryList.${type}`);
  document.body.appendChild(link);
  link.click();
};

export const getLocalStore = (param) => {
  if (!param) {
    param = serverResponse.config.show_in_library
      ? "id_param_url_giodicart"
      : `id_param_url_${serverResponse.leaflet.id_campaign}`;
  }
  let value = localStorage.getItem(param);
  return value !== "" ? JSON.parse(value) : null;
};

export const clearLocalStorage = () => {
  const param = serverResponse.config.show_in_library
    ? "id_param_url_giodicart"
    : `id_param_url_${serverResponse.leaflet.id_campaign}`;
  localStorage.removeItem(param);
};

export const getIdCampaign = () => {
  return serverResponse.leaflet.id_campaign;
};

export const idParamUrlGenerator = () => {
  return Math.random()
    .toString(36)
    .slice(2, 13);
};

export const setLocalStorage = () => {
  let temp_param = JSON.stringify(idParamUrlGenerator());
  let cart_key = serverResponse.config.show_in_library
    ? "id_param_url_giodicart"
    : `id_param_url_${serverResponse.leaflet.id_campaign}`;
  localStorage.setItem(cart_key, temp_param);
  return JSON.parse(temp_param);
};

const getDate = () => {
  let d = new Date();
  return d.toISOString().split("T")[0];
};

export const sendVisit = () => {
  let isSended = sessionStorage.getItem(
    `isSended_${serverResponse.leaflet.id}`
  );
  if (!isSended) {
    sessionStorage.setItem(`isSended_${serverResponse.leaflet.id}`, "true");
    return true;
  }
  return false;
};

export const sendAnalyticsEvent = (event, item = null) => {
  const data = {
    id_cliente: serverResponse.config.client_id,
    id_insegna: serverResponse.config.signboard_id,
    id_utente: serverResponse.config.release_id,
    id_volantino: serverResponse.leaflet.id
  };

  if (serverResponse.config.ga_active) {
    sendEvent({
      ...data,
      evento: event,
      id_item: item
    }).catch((err) => console.log(err));
  } else return;
};

export const getAnalyticsDevice = (isMobile, isTablet, isDesktop) => {
  if (isMobile) return 1;
  else if (isDesktop) return 2;
  else if (isTablet) return 3;
  else return -1;
};

export const getAnalyticsUniqueId = () => {
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = navigator_info.mimeTypes.length;
  uid += navigator_info.userAgent.replace(/\D+/g, "");
  uid += navigator_info.plugins.length;
  uid += screen_info.height || "";
  uid += screen_info.width || "";
  uid += screen_info.pixelDepth || "";
  return uid + "_" + getDate();
};
